// Every route in this app is prefixed by the user's role (super_admin, admin, hod, ed, viewer)
// — see routingData.jsx and the rolePrefix map in DashboardSidebar.jsx. Any absolute navigation
// from inside the Letters module needs to rebuild that prefix, since relative navigation can be
// fragile across differently-nested routes.

const ROLE_PREFIX = {
  super_admin: "super_admin",
  admin: "admin",
  hod: "hod",
  engineer: "ed",
  viewer: "viewer",
};

export function getRolePrefix() {
  const role = sessionStorage.getItem("dpr_role") || "super_admin";
  return ROLE_PREFIX[role] || "super_admin";
}

/** Builds a role-prefixed absolute path, e.g. buildRolePath("letters/123") -> "/super_admin/letters/123" */
export function buildRolePath(path) {
  return `/${getRolePrefix()}/${path}`;
}